/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from "styled-components";

export const redundantCss = (
    camelKey: string,
    kebabKey: string,
    value: unknown
): ReturnType<typeof css> =>
    css({
        [camelKey]: value,
        [kebabKey]: value
    } as any);

function kebabToCamel(key: string): string {
    if (key.startsWith("--")) return key;
    const hasLeadingDash = key.startsWith("-");
    const parts = key.split("-").filter(Boolean);
    if (!parts.length) return key;

    const capitalize = (s: string) =>
        s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;

    const first = parts[0];
    if (!first) return key;
    const rest = parts.slice(1);

    if (hasLeadingDash) {
        return [capitalize(first), ...rest.map(capitalize)].join("");
    }
    return [first, ...rest.map(capitalize)].join("");
}

function camelToKebab(key: string): string {
    if (key.startsWith("Webkit")) {
        return (
            "-webkit-" +
            key
                .slice("Webkit".length)
                .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                .toLowerCase()
        );
    }
    if (key.startsWith("Moz")) {
        return (
            "-moz-" +
            key
                .slice("Moz".length)
                .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                .toLowerCase()
        );
    }
    if (key.startsWith("ms")) {
        return (
            "-ms-" +
            key
                .slice("ms".length)
                .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                .toLowerCase()
        );
    }
    if (key.startsWith("O") && key.length > 1 && /[A-Z]/.test(key.charAt(1))) {
        return (
            "-o-" +
            key
                .slice(1)
                .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
                .toLowerCase()
        );
    }

    return key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}

export const redundantCssFromKebab = (
    kebabKey: string,
    value: unknown
): ReturnType<typeof css> => {
    const camelKey = kebabToCamel(kebabKey);
    const normalizedKebab = kebabKey.includes("-")
        ? kebabKey
        : camelToKebab(kebabKey);
    return redundantCss(camelKey, normalizedKebab, value);
};
